export default "__VITE_ASSET__CSa2VVM4__"